import React from 'react';
import PropTypes from 'prop-types';
import { InputErrorMessage, Spinner } from 'shared/components';
import './styles.scss';

const NumberInput = ({
  disabled,
  error,
  loading,
  handleChange,
  max,
  min,
  ...rest
}) => {
  const handleInputChange = (e) => handleChange(e.target.value);

  return (
    <div className="NumberInput">
      <input
        className={error ? 'has-error' : ''}
        type="number"
        min={min}
        max={max}
        disabled={disabled}
        onChange={handleInputChange}
        {...rest}
      />
      {loading && <Spinner />}
      <InputErrorMessage text={error} />
    </div>
  );
};

NumberInput.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  loading: PropTypes.bool,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

NumberInput.defaultProps = {
  disabled: false,
  error: '',
  handleChange: () => {},
  loading: false,
};

export default NumberInput;
